import React from "react"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import Stack from "@mui/material/Stack"
import { styled } from "@mui/material/styles"
import CTA from "components/atoms/CTA"
import LazyImage from "components/atoms/LazyImage"

export default function ErrorTemplate() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  function retry() {
    navigate(-1)
  }

  return (
    <Container>
      <LazyImage
        src="/static/images/error-template.png"
        alt="error"
        style={{ maxWidth: "200px", maxHeight: "72px" }}
      />
      <p>{t("errorMessage.errorHappened")}</p>
      <CTA
        variant="contained"
        onClick={retry}
      >
        {t("general.back")}
      </CTA>
    </Container>
  )
}

const Container = styled(Stack)(({ theme }) => ({
  height: "100vh",
  justifyContent: "center",
  alignItems: "center",
  gap: "16px",

  "@supports (height: 100dvh)": {
    height: "calc(100dvh)"
  },

  "& p": {
    fontSize: "1.8rem",
    fontWeight: 700,
    color: theme.palette.gray["14"]
  },

  "& button": {
    maxWidth: "200px",
    marginTop: "16px"
  }
}))
